import React from "react";
import { Helmet } from "react-helmet-async";

// Defaults applied when a page does not override a field.
const SITE_URL = "https://hirun.lk";
const DEFAULT_TITLE = "Hirun Kolongahapitiya 🚀 Portfolio";
const DEFAULT_DESCRIPTION =
  "Hirun Kolongahapitiya is a software engineer based in Colombo, Sri Lanka, building full-stack web and mobile products with React, Node.js, Flutter, and AI-driven tooling.";
const DEFAULT_IMAGE = `${SITE_URL}/assets/profile.jpg`;

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | Hirun Kolongahapitiya` : DEFAULT_TITLE;
  const url = path.startsWith("http") ? path : `${SITE_URL}${path}`;
  const absoluteImage = image?.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absoluteImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImage} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
